import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FilterViewModelForOwner } from 'src/app/core/models/regulation/filter-view.model';
import { BulkCheckBoxRule, BulkUpdateRule } from 'src/app/core/models/rulebook/bulk-update-rule';
import { UserProfile } from 'src/app/core/models/user';
import { Role } from 'src/app/core/models/user-management/role';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { CommonService } from 'src/app/core/services/common/common.service';
import { RegulationService } from 'src/app/core/services/regulation';
import { GDPRService } from 'src/app/core/services/rulebook';

@Component({
  selector: 'app-bulk-update-rule-dialog',
  templateUrl: './bulk-update-rule-dialog.component.html',
  styleUrls: ['./bulk-update-rule-dialog.component.scss']
})
export class BulkUpdateRuleDialogComponent implements OnInit{

  allSearchedOwner: FilterViewModelForOwner[] = [];
  searchOwnerCntrl: FormControl = new FormControl();
  ownerExternalIdList: string[] = [];
  user: UserProfile;
  ownerDD: string[] = [];
  @ViewChild('ownerAutocomplete')
  ownerAutocomplete!: any;
  @ViewChild('trigautoOwner')
  trigautoOwner!: MatAutocompleteTrigger;
  @ViewChild('ownerInput')
  ownerInput!: ElementRef<HTMLInputElement>;
  currentUserRole = '';
  updateData: BulkUpdateRule;
  updateCheckboxData: BulkCheckBoxRule;
  toastModel: ToastViewModel;
  isToastShow = false;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  isRead = false;
  isApplicable = false;
  isOperative = false;
  isDataUpdated = false;
  

  constructor(@Inject(MAT_DIALOG_DATA) public selectedIds: Array<number>,public dialogRef: MatDialogRef<BulkUpdateRuleDialogComponent>,
   private regulationService: RegulationService,
   private gdprService: GDPRService,
    private sessionService: SessionService,public commonService: CommonService,){
    this.user = new UserProfile();
    this.updateData = new BulkUpdateRule();
    this.updateCheckboxData = new BulkCheckBoxRule();
    this.toastModel = new ToastViewModel();
  }
  ngOnInit(): void {
    this.getUserProfile();
    this.getOwnerDD();
  }
  getUserProfile(): void {
    this.sessionService.getLoginUserInfo().subscribe((user: UserProfile) => {
      this.user = user;
      // this.user.externalUserId
      if (this.user && this.user.roleId > 0) {
        this.fetchCurrentUserRole();
      }
    });
  }
  fetchCurrentUserRole(): void {
    this.gdprService
      .getCurrentUserRole(this.user.roleId)
      .subscribe((data: Role) => {
        this.currentUserRole = data.title;
      });
  }
  get searchedOwner(): FilterViewModelForOwner[] {
    if (this.searchOwnerCntrl.value != null) {
      const filterValue = this.searchOwnerCntrl.value.toLowerCase();
      return this.allSearchedOwner.filter((obj) =>
        obj.name.toLowerCase().includes(filterValue)
      );
    }
    return this.allSearchedOwner;
  }
  getOwnerDD() {
    this.regulationService
      .getUserListForOwner()
      .subscribe((res: Array<FilterViewModelForOwner>) => {
        this.allSearchedOwner = res;
      });
  }
  filterOwner(search: any): any {
    let sameValue = this.ownerExternalIdList.filter(
      (obj) => obj === search.externalUserId
    );
    if (sameValue.length == 0) {
      this.ownerExternalIdList.push(search.externalUserId);
    }
    return this.searchedOwner.filter((option) =>
      option.name.toLowerCase().includes(search.value.toLowerCase())
    );
  }
  addOwner(event: MatChipInputEvent): void {
    const value = event.value;
    if (!this.ownerAutocomplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.ownerDD.filter((obj) => obj === value);
        if (sameValueRow.length == 0) {
          (this.ownerDD as string[]).push(value);
        }
      }
      event.chipInput!.clear();
      this.searchOwnerCntrl.setValue(null);
    }
  }
  selectedOwnerEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.ownerDD) {
      let sameValueRow = this.ownerDD.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.ownerDD.push(event.option.viewValue);
      }
    } else {
      this.ownerDD = [];
      this.ownerDD.push(event.option.viewValue);
    }
    if (this.ownerInput) {
      this.ownerInput.nativeElement.value = '';
    }
    this.searchOwnerCntrl.setValue(null);
    this.searchOwnerCntrl.disable();
    this.searchOwnerCntrl.enable();
  }
  removeOwner(status: string): void {
    const index = (this.ownerDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.ownerDD as string[]).splice(index, 1);
      (this.ownerExternalIdList as string[]).splice(index, 1);
    }
  }
  updateOwnerRule(): void {
    this.updateData.ownerList = this.ownerDD.toString();
    this.updateData.selectedIds = this.selectedIds;
    this.gdprService.rulebookOwnerBulkUpdate(this.updateData).subscribe((res: string) => {
      this.isDataUpdated = true;
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = 'Owner successfully updated';
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 3000);
    });
  }
  updateCheckRule():void{
    this.updateCheckboxData.isApplicable = this.isApplicable;
    this.updateCheckboxData.isRead = this.isRead;
    this.updateCheckboxData.isOperative = this.isOperative;
    this.updateCheckboxData.selectedIds = this.selectedIds;
    this.gdprService.rulebookCheckBoxBulkUpdate(this.updateCheckboxData).subscribe((res: string) => {
      this.isDataUpdated = true;
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = 'Rule condition successfully updated';
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 3000);
    });
  }
  closeAction() {
    if(this.isDataUpdated){
      this.dialogRef.close("Success");
    }
    else{
      this.dialogRef.close("Failure");
    }
  }
}
